// src/api/apiResponse.js
import { AUTH_TOKEN_KEY } from './authApi';

/** Only wipe session when the server rejected our token, not when the header never arrived. */
export const shouldLogoutOn401 = (message) => {
  const msg = (message || '').toLowerCase();
  if (msg.includes('missing authentication')) return false;
  return true;
};

export const handleApi401 = (response, data) => {
  if (response.status !== 401) return;

  const message = data?.message || '';
  if (shouldLogoutOn401(message)) {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    window.dispatchEvent(new Event('auth:unauthorized'));
  }
};

export const parseApiResponse = async (response) => {
  const data = await response.json().catch(() => ({}));

  handleApi401(response, data);

  if (!response.ok || data.success === false) {
    const err = new Error(data.message || `HTTP Error: ${response.status}`);
    err.status = response.status;
    err.isAuthError = response.status === 401 && shouldLogoutOn401(data?.message);
    throw err;
  }

  return data;
};
